import React, { Divider, Grid, Paper, Typography } from '@mui/material';
import { OfflineBolt } from '@mui/icons-material';
import { StatisticsService } from 'services';
import { useQuery } from '@tanstack/react-query';
import { ErrorHandler, Loader, Statistics } from 'components';

export const QuickStatus = () => {
	const { data, error, isFetching, isLoading } = useQuery({
		queryKey: ['quickStatusData'],
		queryFn: StatisticsService.quickStatusData,
	});

	return (
		<>
			<Grid container>
				<Grid item xs={12} pl={2}>
					<Typography variant='h4'>
						<OfflineBolt />
						Quick Status
					</Typography>
				</Grid>
			</Grid>
			<Divider sx={{ my: 1 }} />
			<Loader active={(isLoading || isFetching)} />
			<ErrorHandler message={error?.message} />
			<Grid container component={Paper}>
				<Grid item md={6} xs={12} component={Paper}>
					<Statistics status={data?.weeklyStatus} title={'Weekly Status'} />
				</Grid>
				<Grid item md={6} xs={12} component={Paper}>
					<Statistics status={data?.monthlyStatus} title={'Monthly Status'} />
				</Grid>
			</Grid>
		</>
	);
};
